import DefaultOrderedList from '@tiptap/extension-ordered-list';
import { mergeAttributes, wrappingInputRule } from '@tiptap/core';
import { OrderedListOptions } from '@tiptap/extension-ordered-list/src/ordered-list';

// WEB-12885 - Changing the input regex to not allow leading zeros (unless it's just "0.")
export const inputRegex = /^(0|[1-9][0-9]*)\.\s$/;
const TextStyleName = 'textStyle';

export const OrderedList = DefaultOrderedList.extend({
    addOptions() {
        return {
            ...(this.parent?.() as OrderedListOptions),
            HTMLAttributes: { class: 'list-el' },
        };
    },

    /**
     * WEB-11755 - Due to a Chrome bug, we need to use custom list counters.
     *   In order to allow the "start" attribute to work correctly, we need to set the
     *   `--list-start` CSS variable to the value of the "start" attribute.
     *
     *   So this just overrides the OOTB renderHTML method to set the CSS variable.
     */
    renderHTML({ HTMLAttributes }) {
        const { start, ...attributesWithoutStart } = HTMLAttributes;

        const attributesWithStart = {
            ...HTMLAttributes,
            style: `--list-start: ${start - 1}`,
        };

        return start === 1
            ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0]
            : ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithStart), 0];
    },

    addKeyboardShortcuts() {
        return {
            /* eslint-disable @typescript-eslint/naming-convention */
            // Keeping the original Tiptap shortcut, in case it's standard
            'Mod-Shift-7': () => this.editor.commands.toggleOrderedList(),
            'Mod-Shift-O': () => this.editor.commands.toggleOrderedList(),
        };
    },

    // WEB-12885 - This is a copy of the OOTB method, but with our custom inputRegex to prevent leading zeros
    addInputRules() {
        let inputRule = wrappingInputRule({
            find: inputRegex,
            type: this.type,
            getAttributes: (match) => ({ start: +match[1] }),
            joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
        });

        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = wrappingInputRule({
                find: inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: (match) => ({ start: +match[1], ...this.editor.getAttributes(TextStyleName) }),
                joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
                editor: this.editor,
            });
        }
        return [inputRule];
    },
});
